<div class="page">
    <app-breadcrumb
        [paths]="paths"
    >
    </app-breadcrumb>
    @if (title) { <h2 class="otic-page-title">{{title}}</h2> }
    <ng-content></ng-content>
</div>
